import { baseAxios } from "config";

export const fetchInterviewSuggestionInformation = async ({
  jobSlug,
  applicantId,
  userId,
  date,
  code,
  outsideMode = "",
}) => {
  try {
    const outsideModeQuery = !outsideMode ? "" : `outside-${outsideMode}/`;
    const res = await baseAxios.get(
      `/${outsideModeQuery}events/interview/suggestion?jobSlug=${jobSlug || ""}&applicantId=${
        applicantId || ""
      }&userId=${userId || ""}&date=${date || ""}&code=${code || ""}`
    );
    return res.data;
  } catch (err) {
    // Extract and preserve the actual error message from the API
    console.log("API Error Response:", err.response?.data);

    if (err.response?.data?.message) {
      return err.response?.data;
    }

    if (err.response?.data?.error) {
      // eslint-disable-next-line no-throw-literal
      throw {
        apiError: true,
        message: err.response.data.error,
        originalError: err,
      };
    }
    throw new Error(err?.response?.data?.message?.toString() ?? err.toString());
  }
};
